import styles from './index.module.css'

import React from 'react'

import { Box, Flex } from 'components/ds'
import Skeleton from 'components/ui/skeleton'

const WAVEFORM_HEIGHT = 48

/**
 * Loading placeholder for the SimilarityPlayer. Rendered above (or in the top
 * row of) the results table while a similarity search is in flight, before the
 * real player can mount. Mirrors the player's loading row — play button +
 * waveform — and reuses the player's own waveform skeleton markup so the
 * handoff to the real player is seamless (no second, different-looking loader).
 */
const SimilarityPlayerSkeleton = (): React.ReactNode => (
  <Flex
    align="center"
    gap="3"
    width="100%"
    data-testid="similarity-player-skeleton"
  >
    <Box className={styles.skeletonPlayButton}>
      <Skeleton type="block" lines={1} />
    </Box>
    <Box className={styles.waveformContainer}>
      <Flex height={`${WAVEFORM_HEIGHT}px`} align="center" justify="center">
        <Box className={styles.skeletonWrapper}>
          <Skeleton type="block" lines={1} />
        </Box>
      </Flex>
    </Box>
  </Flex>
)

export default SimilarityPlayerSkeleton
